var TagStyle;
(function (TagStyle) {
    TagStyle["TRANSPARENT"] = "transparent";
    TagStyle["1_GREY"] = "1-grey";
    TagStyle["2_GREEN"] = "2-green";
    TagStyle["3_GREY"] = "3-grey";
    TagStyle["3_BLUE"] = "3-blue";
    TagStyle["3_GREEN"] = "3-green";
    TagStyle["3_RED"] = "3-red";
    TagStyle["3_PURPLE"] = "3-purple";
    TagStyle["3_ORANGE"] = "3-orange";
    TagStyle["3_GHOST"] = "3-ghost";
    TagStyle["4_BLACK"] = "4-black";
    TagStyle["4_BLUE"] = "4-blue";
    TagStyle["4_GREEN"] = "4-green";
    TagStyle["4_PURPLE"] = "4-purple";
    TagStyle["5_BLACK"] = "5-black";
    TagStyle["6_GREY"] = "6-grey";
    TagStyle["7_GREY"] = "7-grey";
})(TagStyle || (TagStyle = {}));

export { TagStyle };
